
(function () {

    'use strict';
    angular.module('imAnalytics')
        .service('imTrackingCommonService', ['$window', '$rootScope', 'imEventService', 'imCommonUserService', imTrackingCommonService]);

    function imTrackingCommonService($window, $rootScope, imEventService, imCommonUserService) {

        return {
            pageContext: pageContext,
            eventServerError: eventServerError,
            eventFormError: eventFormError,
            eventPaymentOk: eventPaymentOk,
            sendTerms: sendTerms
        };

        /**
         * Add Base Context to pageview
         */
        function baseContext() {
            var baseContext;
            baseContext = {
                context: {
                    platform: 'web-responsive',
                    codeVersion: '8.8.0',
                    storeId: getStoreId(),
                    language: getLanguage(),
                    isOpenStore: getIsOpen()
                },
                page: {
                    pageURL: document.location.href,
                    countryCode: inditex.iCountryCode,
                    categoryId: undefined
                },
                user: {
                    isLogged: imCommonUserService.isLogged(),
                    userId: imCommonUserService.userId()
                }
            };
            return baseContext;
        }

        function getIsOpen() {
            if (inditex.iStoreJSON) {
                return inditex.iStoreJSON.isOpenForSale ? 'abierta' : 'cerrada';
            } else {
                return undefined;
            }
        }

        function getLanguage() {
            if (inditex.iLocale) {
                return inditex.iLocale.substring(0, 2).toLowerCase();
            } else {
                return undefined;
            }
        }

        function getStoreId() {
            if (inditex.iPage === 'ItxWorldWidePage') {
                return 'DUTTI_ZZ';
            } else {
                if (inditex.iStoreIdentifier) {
                    return inditex.iStoreIdentifier.replace(/(.*)([a-zA-Z]{2})/, '$1_$2').toUpperCase();
                } else {
                    return 'DUTTI_XX';
                }
            }
        }

        function pageContext(section, pageType, pageTitle) {
            var baseCtx = baseContext();
            baseCtx.page.section = section;
            baseCtx.page.pageType = pageType;
            baseCtx.page.pageTitle = pageTitle;
            return baseCtx;
        }

        /**
         * Para los eventos de error en el server
         * @param  {string} cf       Categoria funcional del evento
         * @param  {string} category Categoria del evento
         * @param  {string} form Nombre o id del formulario
         * @param  {string} error      Error completo server
         */
        function eventServerError(cf, category, form, error) {
            var eventData = {
                'eventData': {
                    'cf': cf,
                    'category': category,
                    'action': 'error_servidor_' + (form ? form.$name : 'default'),
                    'label': errorCode(error.code, error.errorKey)
                }
            };
            imEventService.analyticsEvent([
                eventData
            ]);
        }
        /**
         * Return  el código de error del servidor
         * @param  {string} code es el parámetro code de la respuesta del server
         * @param  {string} key  es el parámetro key de la respuesta del server
         * @return {string}     Devuelve la acción parseada de un error en el servidor
         */
        function errorCode(code, key) {
            return 'cod_' + (code ? code : '0') + '-desc_' + (key ? key : 'unknown');
        }

        /**
         * Para los eventos de error en los campos del formulario se le pasa el formulario con el que se trabaja
         * @param  {string} cf       [description]
         * @param  {string} category [description]
         * @param  {string} form      [Objecto con las características del formulario]
         *
         */
        function eventFormError(cf, category, form) {
            var action;
            action = 'error_' + form.$name;

            angular.forEach(form, function (value) {
                if ((typeof value !== 'undefined') && (value.hasOwnProperty('$modelValue')) && (value.$invalid)) {
                    var eventData = {
                        'eventData': {
                            'cf': cf,
                            'category': category,
                            'action': action,
                            'label': value.$name
                        }
                    };
                    imEventService.analyticsEvent([
                        eventData
                    ]);
                }
            });
        }

        function sendTerms() {
            var data, eventData, hash, category;
            hash = document.location.hash;
            data = [];
            category = 'acceso_registro';
            if (hash.match('summary')) {
                category = 'resumen_compra';
            } else if (hash.match('shipping')) {
                category = 'envio';
            }

            eventData = {
                'eventData': {
                    'cf': 'legal',
                    'category': category,
                    'action': 'ver_politica_privacidad',
                    'label': undefined
                }
            };
            data.push(eventData);
            imEventService.analyticsEvent(data);
        }

        /**
         * Para los eventos de pago correcto
         * @param  {string} cf       [description]
         * @param  {string} category [description]
         * @param  {string} action   [description]
         * @param  {string} label    [description]
         */
        function eventPaymentOk(cf, category, action, label) {

            var eventData = {
                'eventData': {
                    'cf': cf,
                    'category': category,
                    'action': action,
                    'label': label
                }
            };

            imEventService.analyticsEvent([eventData]);
        }
    }
})();



(function () {

    'use strict';

    function imCommonUserService() {

        return {
            userId: userId,
            userType: userType,
            getGender: getGender,
            isQuickbuy: isQuickbuy,
            clientType: clientType,
            isBuyer: isBuyer,
            isLogged: isLogged
        };

        function isLogged() {
            if (inditex.iUserJSON) {
                if (inditex.iUserJSON.userType === 'R') {
                    return 'logueado';
                }
                else {
                    return 'no_logueado';
                }
            }
            return 'no_logueado';
        }

        /**
         * Si el userId > 0 está logueado
         */
        function userId() {
            if (inditex.iUserJSON) {
                if (inditex.iUserJSON.identity) {
                    return inditex.iUserJSON.identity.userId > 0 ? inditex.iUserJSON.identity.userId : undefined;
                } else {
                    return undefined;
                }
            } else {
                return undefined;
            }
        }

        function userType() {
            if (inditex.iUserJSON && inditex.iUserJSON.userType === 'R') {
                return 'registrado';
            } else {
                return 'anonimo';
            }
        }

        function getGender() {
            if (inditex.iUserJSON && inditex.iUserJSON.gender === 'F') {
                return 'femenino';
            } else {
                return 'masculino';
            }
        }

        function isQuickbuy() {
            if (inditex.iUserJSON && inditex.iUserJSON.isWalletUser) {
                return 'si';
            } else {
                return 'no';
            }
        }

        function clientType() {
            if (inditex.iUserJSON && inditex.iUserJSON.isCompany) {
                return 'empresa';
            } else {
                return 'particular';
            }
        }

        function isBuyer() {
            if (inditex.iUserJSON && inditex.iUserJSON.isBuyer) {
                return 'si';
            } else {
                return 'no';
            }
        }
    }

    angular.module('imAnalytics')
        .service('imCommonUserService', [imCommonUserService]);
})();

(function () {
    'use strict';

    function imAccessService(imEventService, imTrackingCommonService, imCommonUserService) {

        function getSection() {
            var section = 'perfil_usuario';
            if (inditex.iPage === 'ItxCheckoutAuthPage' || inditex.iPage === 'ItxOrderConfirmationPage') {
                section = 'checkout';
            }
            return section;
        }
        function getCf() {
            var cf = 'perfil_usuario';
            if (inditex.iPage === 'ItxCheckoutAuthPage' || inditex.iPage === 'ItxOrderConfirmationPage') {
                cf = 'perfil_comprador';
            }
            return cf;
        }
        function eventSessionOK(category, action) {
            var data, eventData, extraDimensions;
            data = [];
            eventData = {
                'eventData': {
                    'cf': getCf(),
                    'category': category,
                    'action': action,
                    'label': ''
                }
            };
            extraDimensions = {
                customData: {
                    'user': {
                        'userType': imCommonUserService.userType(),
                        'userId': imCommonUserService.userId(),
                        'isBuyer': imCommonUserService.isBuyer(),
                        'quickBuy': imCommonUserService.isQuickbuy(),
                        'clientType': imCommonUserService.clientType(),
                        'age': undefined,
                        'sex': imCommonUserService.getGender()
                    }
                }
            };
            data.push(eventData, extraDimensions);
            sendEvent(data);

        }

        function createView(pageType, pageTitle) {
            var data = [];
            data.push(imTrackingCommonService.pageContext(getSection(), pageType, pageTitle));
            sendPageview(data);
        }
        /**
         * Que tipo de vista lanzar en cada momento
         * @param  {string} type de vista
         */
        function triggerView(type) {
            if (type === 'login') {
                createView('acceso', 'login');
            } else if (type === 'register') {
                createView('acceso', 'registro');
            }
            else if (type === 'recover-password') {
                createView('acceso', 'recuperar_contrasena');
            }
            else if (type === 'recover-password-success') {
                //Una espera para que se realice correctamente la peticion de recuperar_contrasena_ok
                // y evitar que se lance en esta pantalla
                setTimeout(function () {
                    createView('acceso', 'recuperar_contrasena/email');
                }, 1000);
            }
            else if (type === 'recover-password-sms') {
                //Una espera para que se realice correctamente la peticion de
                //recuperar_contrasena_ok y evitar que se lance en esta pantalla
                setTimeout(function () {
                    createView('acceso', 'recuperar_contrasena/sms');
                }, 1000);
            }
            else if (type === 'change-password') {
                createView('acceso', 'recuperar_contrasena/modificar');
            }
            else if (type === 'change-password-success') {
                //Una espera para que se realice correctamente la peticion de recuperar_contrasena_ok
                //y evitar que se lance en esta pantalla
                setTimeout(function () {
                    createView('acceso', 'recuperar_contrasena/modificar/confirmacion');
                }, 1000);
            }
        }

        function sendPageview(data) {
            imEventService.pageView(data);
        }
        //Se resuelve finalmente con un setTimeout
        function recoveryPasswordOK() {
            var data, eventData;
            data = [];
            eventData = {
                'eventData': {
                    'cf': getCf(),
                    'category': 'recuperar_contrasena',
                    'action': 'recuperar_contrasena_ok',
                    'label': ''
                }
            };
            data.push(eventData);
            sendEvent(data);
        }

        function createEvent(category, action, label, cf) {
            var data, eventData;
            data = [];
            eventData = {
                'eventData': {
                    'cf': cf || getCf(),
                    'category': category,
                    'action': action
                }
            };
            if (label) {
                eventData['eventData'].label = label;
            }
            if (
                (action === 'alta_newsletter_ok' || action === 'alta_fidelizacion_ok') &&
                eventData['eventData'] &&
                eventData['eventData'].cf &&
                !cf
            ) {
                eventData['eventData'].cf = 'fidelizacion';
            }
            data.push(eventData);
            sendEvent(data);
        }

        function sendEvent(data) {
            imEventService.analyticsEvent(data);

        }

        function createForm(category, form) {
            imTrackingCommonService.eventFormError(getCf(), category, form);
        }

        function createServer(category, form, error) {
            imTrackingCommonService.eventServerError(getCf(), category, form, error);
        }



        return {
            createView: createView,
            eventSessionOK: eventSessionOK,
            createEvent: createEvent,
            createForm: createForm,
            createServer: createServer,
            recoveryPasswordOK: recoveryPasswordOK,
            triggerView: triggerView,
        };
    }
    angular.module('imAnalytics')
        .service('imAccessService', [
            'imEventService',
            'imTrackingCommonService',
            'imCommonUserService',
            imAccessService
        ]);
})();

(function () {
    'use strict';

    function imShippingService(imEventService, imTrackingCommonService) {

        function triggerNextStep() {
            var data, eventData;
            data = [];
            eventData = {
                'eventData': {
                    'cf': 'checkout',
                    'category': 'envio',
                    'action': 'siguiente_paso',
                    'label': ''
                }
            };
            data.push(eventData);
            sendEvent(data);
        }

        function selectShipping(type) {
            var data, eventData;
            data = [];
            eventData = {
                'eventData': {
                    'cf': 'checkout',
                    'category': 'envio',
                    'action': 'seleccionar_envio',
                    'label': type
                }
            };
            data.push(eventData);
            sendEvent(data);
            /**
             * Lanzamos aquí tambien el evento siguiente paso
             */
            triggerNextStep();
        }
        function selectedFavorite(storeId) {
            var data, eventData;
            data = [];
            eventData = {
                'eventData': {
                    'cf': 'checkout',
                    'category': 'envio',
                    'action': 'seleccionar_tienda_favorita',
                    'label': storeId
                },
                'customData': {
                    'store': {
                        'storeId': storeId
                    }
                }
            };
            data.push(eventData);
            sendEvent(data);
        }
        function createEvent(cf, action, label) {
            var data, eventData;
            data = [];
            eventData = {
                'eventData': {
                    'cf': cf,
                    'category': 'envio',
                    'action': action,
                    'label': label
                }
            };
            data.push(eventData);
            sendEvent(data);
        }
        function sendEvent(data) {
            imEventService.analyticsEvent(data);
        }
        function getZipcode(shippingData) {
            if (shippingData && 'zipCode' in shippingData) {
                return shippingData.zipCode;
            } else {
                return undefined;
            }
        }
        //Usar tambien para modificar la direccion
        function addAddress(shippingData) {
            var data, eventData, action, zipcode;
            data = [];
            zipcode = getZipcode(shippingData);
            action = 'anadir_direccion_ok';
            //Para distinguir si se edita o se anade una direccion se  distingue si aparecen X en el div
            if (angular.element('#page  itx-shipping-delivery ul.checkout-list.shipping-list')
                .find('i.icon').length > 0) {
                action = 'modificar_direccion_ok';
            }
            eventData = {
                'eventData': {
                    'cf': 'perfil_comprador',
                    'category': 'envio',
                    'action': action,
                    'label': zipcode
                },
                'customData': {
                    'store': {
                        'zipCode': zipcode
                    }
                }
            };
            data.push(eventData);
            sendEvent(data);
        }

        function createForm(form) {
            var cf = 'perfil_comprador';
            var category = 'envio';
            imTrackingCommonService.eventFormError(cf, category, form);
        }
        function createServer(form, error) {
            var cf = 'perfil_comprador';
            var category = 'envio';
            imTrackingCommonService.eventServerError(cf, category, form, error);
        }

        return {
            createEvent: createEvent,
            createForm: createForm,
            createServer: createServer,
            addAddress: addAddress,
            selectShipping: selectShipping,
            selectedFavorite: selectedFavorite
        };
    }
    angular.module('imAnalytics')
        .service('imShippingService', [
            'imEventService',
            'imTrackingCommonService',
            imShippingService
        ]);
})();

(function () {
    'use strict';

    function imLocatorService(imEventService, imTrackingCommonService) {

        function createView(isDropPoint, nearStores) {
            if (inditex.iPage !== 'ItxMyAccountPage') {

                var data = [];
                var section = '';
                var pageType = '';
                var pageTitle = '';
                switch (inditex.iPage) {

                    case 'ItxStoreLocatorPage':
                        section = 'localizador_tiendas';
                        pageType = 'localizar';
                        pageTitle = nearStores ? 'lista' : 'buscador';
                        break;

                    case 'ItxCheckoutPage':
                        section = 'checkout';
                        pageType = 'envio';
                        if (isDropPoint) {
                            pageTitle = nearStores ?
                                'localizador_droppoint/localizar/lista' : 'localizador_droppoint/localizar/buscador';
                        } else {
                            pageTitle = nearStores ?
                                'localizador_tiendas/localizar/lista' : 'localizador_tiendas/localizar/buscador';
                        }
                        break;

                    default:
                        section = 'localizador_tiendas';
                        pageType = 'localizar';
                        pageTitle = nearStores ? 'lista' : 'buscador';
                        break;
                    
                }
                data.push(imTrackingCommonService.pageContext(section, pageType, pageTitle));
                if (nearStores) {
                    data.push({
                        'store': {
                            'storeFound': nearStores
                        }
                    });
                }
                sendPageview(data);
            }
        }

        function sendPageview(data) {
            if (inditex.iPage === 'ItxStoreLocatorPage') {
                imEventService.pageView(data);
            } else {
                imEventService.popupView(data);
            }
        }

        function searchStore(searchTerm, isDropPoint) {
            if (inditex.iPage !== 'ItxMyAccountPage') {

                var eventData = [{
                    'eventData': {
                        'cf': isDropPoint ? 'localizador_droppoint' : 'localizador_tiendas',
                        'category': inditex.iPage === 'ItxStoreLocatorPage' ? 'localizador_tiendas' : 'envio',
                        'action': isDropPoint ? 'localizar_droppoint' : 'localizar_tiendas',
                        'label': searchTerm
                    },
                    'customData': {
                        'store': {
                            'zipCode': 'cd75'
                        }
                    }
                }];
                sendEvent(eventData);

            }

        }

        function clickStore(store, target, isDropPoint) {

            if (inditex.iPage !== 'ItxMyAccountPage') {
                var eventData = [{
                    'eventData': {
                        'cf': isDropPoint ? 'localizador_droppoint' : 'localizador_tiendas',
                        'category': inditex.iPage === 'ItxStoreLocatorPage' ? 'localizador_tiendas' : 'envio',
                        'action': target ? 'desplegar_lista' : 'desplegar_mapa',
                        'label': store ? store.id : undefined
                    },
                    'customData': {
                        'store': {
                            'storeId': !isDropPoint && store ? store.id : undefined,
                            'dropPoint': isDropPoint && store ? store.id : undefined
                        }
                    }
                }];
                sendEvent(eventData);

            }
        }

        function selectStore(store, isDropPoint) {
            if (inditex.iPage !== 'ItxMyAccountPage') {

                var eventData = [{
                    'eventData': {
                        'cf': isDropPoint ? 'localizador_droppoint' : 'localizador_tiendas',
                        'category': 'envio',
                        'action': isDropPoint ? 'seleccionar_droppoint' : 'seleccionar_tienda',
                        'label': store ? store.id : undefined
                    },
                    'customData': {
                        'store': {
                            'storeId': !isDropPoint && store ? store.id : undefined,
                            'dropPoint': isDropPoint && store ? store.id : undefined
                        }
                    }
                }];
                sendEvent(eventData);
            }
        }

        function addFavouriteStore(store){
            if (inditex.iPage !== 'ItxMyAccountPage') {
                var eventData = [{
                    'eventData': {
                        'cf': 'perfil_comprador ',
                        'category': inditex.iPage === 'ItxCheckoutPage' ? 'envio' : 'localizador_tiendas',
                        'action': 'anadir_tienda_favorita' ,
                        'label': store ? store.id : undefined
                    },
                    'customData': {
                        'store': {
                            'storeId': store ? store.id : undefined,
                        }
                    }
                }];
                sendEvent(eventData);
            }
        }

        function removeFavouriteStore(store){
            if (inditex.iPage !== 'ItxMyAccountPage') {
                var eventData = [{
                    'eventData': {
                        'cf': 'perfil_comprador ',
                        'category': inditex.iPage === 'ItxCheckoutPage' ? 'envio' : 'localizador_tiendas',
                        'action': 'eliminar_tienda_favorita' ,
                        'label': store ? store.id : undefined
                    },
                    'customData': {
                        'store': {
                            'storeId': store ? store.id : undefined,
                        }
                    }
                }];
                sendEvent(eventData);
            }
        }

        function searchNearbyStores(isDropPoint){
            if (inditex.iPage !== 'ItxMyAccountPage') {
                var eventData = [{
                    'eventData': {
                        'cf': isDropPoint ? 'localizador_droppoint' : 'localizador_tiendas',
                        'category': inditex.iPage === 'ItxCheckoutPage' ? 'envio' : 'localizador_tiendas',
                        'action': isDropPoint ? 'consultar_droppoints_cercanos ' : 'consultar_tiendas_cercanas ',
                    }
                }];
                sendEvent(eventData);
            }
        }

        function sendEvent(data) {
            imEventService.analyticsEvent(data);
        }

        return {
            createView: createView,
            searchStore: searchStore,
            selectStore: selectStore,
            clickStore: clickStore,
            addFavouriteStore: addFavouriteStore,
            removeFavouriteStore: removeFavouriteStore,
            searchNearbyStores: searchNearbyStores
        };
    }
    angular.module('imAnalytics')
        .service('imLocatorService', [
            'imEventService',
            'imTrackingCommonService',
            imLocatorService
        ]);
})();